// extracted by mini-css-extract-plugin
module.exports = {"customBtn":"Button_customBtn__2WCx5","customBtnPrimary":"Button_customBtnPrimary__3bOQX"};